import { render } from "./LayoutSegment.vue?vue&type=template&id=3958e832&scoped=true"
import script from "./LayoutSegment.vue?vue&type=script&lang=js"
export * from "./LayoutSegment.vue?vue&type=script&lang=js"

import "./LayoutSegment.vue?vue&type=style&index=0&id=3958e832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3958e832"]])

export default __exports__